<template>
	<div id="main">
		<div class="flex flex-start chart-control-bar text-left" style="padding: 15px; flex-flow: row wrap;">
			<div>
				<span>条件统计：</span>
				<el-select v-model="defaultTypeValue" placeholder="请选择" @change="selectChange">
					<el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="block" style="margin-left: 20px;">
				<span>自定义统计：</span>
				<el-date-picker
					unlink-panels
					v-model="date_range"
					value-format="yyyy-MM-dd"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="chooseDate"
				></el-date-picker>
			</div>
		</div>
		<div class="increase">
			<div>
				<div class="icondiv" :style="'background:rgba' + rgb()"><i class="el-icon-sell"></i></div>
				<div class="increaseData" @click="topage('/document/index')">
					<p>新增内容条数</p>
					<p class="bigtext">{{ data.news_total }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: 'home',
	data() {
		return {
			data: {
				orderIncrease: '0',
				rent_calc: '0',
				rent_ing: '0',
				newOrder: '0'
			},
			date_range: '',
			types: [
				{
					label: '本周',
					value: 1
				},
				{
					label: '本月',
					value: 2
				},
				{
					label: '本年',
					value: 3
				},
				{
					label: '上周',
					value: 4
				},
				{
					label: '上月',
					value: 5
				}
			],
			defaultTypeValue: 1
		};
	},
	computed: {
		...mapState({
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		// 数据统计
		statistics(type) {
			this.$axios({
				url: this.HOST + '/admin.document/statistics',
				method: 'post',
				data: {
					adminid: this.userInfo.id,
					token: this.userInfo.token,
					type: type,
					typeValue: this.defaultTypeValue,
					date_range: this.date_range
				}
			})
				.then(res => {
					console.log(res);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log(res.data);
						this.data = res.data;
					}
				})
				.catch(err => {});
		},
		rgb() {
			//rgb颜色随机
			var r = Math.floor(Math.random() * 256);
			var g = Math.floor(Math.random() * 256);
			var b = Math.floor(Math.random() * 256);
			var rgb = '(' + r + ',' + g + ',' + b + ')';
			console.log(rgb);
			return rgb;
		},
		topage(page) {
			this.$router.push(page);
		},
		chooseDate(e) {
			console.log(this.date_range);
			this.defaultTypeValue = '';
			this.statistics(2);
		},
		selectChange(e) {
			this.defaultTypeValue = e;
			this.statistics(1);
		}
	},
	mounted() {
		this.statistics(1);
	}
};
</script>

<style>
.increase {
	display: flex;
	justify-content: flex-start;
	flex-flow: row wrap;
	padding: 15px;
}
.increase > div {
	min-width: 47%;
	margin-right: 3%;
	display: flex;
	box-shadow: 0 0 15px #eee;
	margin-bottom: 30px;
}
@media screen and (max-width: 700px) {
	.increase > div {
		min-width: 90%;
	}
}
.icondiv {
	padding: 35px 25px;
	color: #fff;
	font-size: 30px;
}
.increaseData {
	flex: 1;
	padding: 25px;
	cursor: pointer;
}
.charts {
	display: flex;
	justify-content: flex-start;
	flex-flow: row wrap;
}
.echart {
	width: 30%;
	min-width: 300px;
	height: 300px;
	margin: 20px auto;
	border: 1px solid #ccc;
}
.echart canvas {
}

.bigtext {
	font-size: 30px;
}
</style>
